<template>
  <div>
    <b-row>
      <b-col cols="12">
        <FITFormCard style="width: 100%; height: 100% ;">
          <div slot="header">
            <h5>Reminders</h5>
          </div>
          <div slot="formBody" style="width: 100%;  min-height: 44vh; max-height: 44vh; ">
            <b-tabs justified fill v-model="tabIndex">
              <b-tab :title="$t('home.message.headers.birthday')">
                <InfinityScrollList apiAction="Homepage/getBirthdayList" class="mt-2"></InfinityScrollList>
              </b-tab>
              <b-tab :title="$t('home.message.headers.renewal')">
                <InfinityScrollList apiAction="Homepage/getRenewalList" :extra="{ simple: false, formatted: true }" class="mt-2"></InfinityScrollList>
              </b-tab>
              <b-tab :title="$t('home.message.headers.serviceRecord')">
                <InfinityScrollList apiAction="Homepage/getMessageList" :extra="{ simple: false, formatted: true }" class="mt-2"></InfinityScrollList>
              </b-tab>
            </b-tabs>
          </div>
        </FITFormCard>
      </b-col>
    </b-row>
  </div>
</template>
<script type="text/javascript">
import {
  Message,
  InfinityScrollList,
  Renewal
} from './components';

import {
  FITPagination
} from '@/components';

import { FITFormCard } from '@/components'

export default {
  name: 'NotificationTabContainer',
  components: {
    Message,
    InfinityScrollList,
    Renewal,
    FITFormCard,
    FITPagination
  },
  data() {
    return {
      tabIndex: 0
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Homepage/components/Notification/NotificationTabContainer.vue